import { render } from "./RedirectView.vue?vue&type=template&id=28edb279&lang=html"
import script from "./RedirectView.vue?vue&type=script&lang=js"
export * from "./RedirectView.vue?vue&type=script&lang=js"

import "./RedirectView.vue?vue&type=style&index=0&id=28edb279&lang=css"

import exportComponent from "C:\\Users\\dlin\\Desktop\\work\\webportal-lms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__